import celebrations from './celebrations/celebrations.component';
import component from './care.component';
import prayers from './prayers/prayers.component';

export default angular.module('mpdx.home.care', [celebrations, prayers, component]).name;
